import { apiGet, apiPost, apiPut, apiDelete, parseJsonResponse } from './apiClient';

export const listUsers = () =>
  apiGet('/helper/acl/users?populate=role').then(parseJsonResponse);

export const getUser = (userId) =>
  apiGet(`/helper/acl/users/${userId}?populate=role`).then(parseJsonResponse);

export const deleteUser = (userId) =>
  apiDelete(`/helper/acl/users/${userId}`);

export const saveUser = (userId, data) =>
  userId
    ? apiPut(`/helper/acl/users/${userId}`, data).then(parseJsonResponse)
    : apiPost('/users', data).then(parseJsonResponse);
